
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comparison/[slug]",
      function () {
        return require("private-next-pages/comparison/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/comparison/[slug]"])
      });
    }
  